// ── SCROLL & HOVER DEL HEADER ──────────────────────────
const header = document.querySelector('.tt-desktop-header');
let lastScroll = 0;

const esPaginaContacto = window.location.pathname.includes('/pages/contact');

window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;

    if (currentScroll > 50) {
        header.classList.add('scrolled');
    } else {
        header.classList.remove('scrolled');
    }

    if (currentScroll <= 0) {
        header.classList.remove('scroll-up', 'scroll-down');
        lastScroll = currentScroll;
        return;
    }

    if (!esPaginaContacto) {
        if (currentScroll > lastScroll && !header.classList.contains('scroll-down')) {
            header.classList.remove('scroll-up');
            header.classList.add('scroll-down');
            header.classList.remove('menu-hover');
        } else if (currentScroll < lastScroll && header.classList.contains('scroll-down')) {
            header.classList.remove('scroll-down');
            header.classList.add('scroll-up');
        }
    } else {
        header.classList.add('scroll-up');
        header.classList.remove('scroll-down');
    }

    lastScroll = currentScroll;
});

document.addEventListener('DOMContentLoaded', function() {
    const submenus = document.querySelectorAll('.tt-desktop-header li.tt-submenu');
    submenus.forEach(item => {
        item.addEventListener('mouseenter', () => {
            header.classList.add('menu-hover');
        });
        item.addEventListener('mouseleave', () => {
            header.classList.remove('menu-hover');
        });
    });
});

// ── STAGGER FOOTER + SMOOTH OPEN/CLOSE (solo mobile) ──
(function () {
    var MOBILE_BREAKPOINT = 1024;
    var DELAY = 80;

    function isMobile() {
        return window.innerWidth < MOBILE_BREAKPOINT;
    }

    function getItems(content) {
        var items = [];
        content.querySelectorAll('ul.tt-list li').forEach(function (el) { items.push(el); });
        content.querySelectorAll('address p').forEach(function (el) { items.push(el); });
        content.querySelectorAll('address span').forEach(function (el) { items.push(el); });
        return items;
    }

    function animateIn(content) {
        var items = getItems(content);
        items.forEach(function (el) {
            el.classList.remove('sj-visible');
            el.classList.add('sj-reset');
        });
        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                items.forEach(function (el, i) {
                    el.classList.remove('sj-reset');
                    setTimeout(function () {
                        el.classList.add('sj-visible');
                    }, i * DELAY);
                });
            });
        });
    }

    function animateOut(content) {
        getItems(content).forEach(function (el) {
            el.classList.remove('sj-visible');
            el.classList.add('sj-reset');
        });
    }

    function getFullHeight(content) {
        var prev = {
            display: content.style.display,
            maxHeight: content.style.maxHeight,
            transition: content.style.transition,
            overflow: content.style.overflow
        };
        content.style.transition = 'none';
        content.style.maxHeight = 'none';
        content.style.display = 'block';
        content.style.overflow = 'hidden';
        var h = content.offsetHeight;
        content.style.display = prev.display;
        content.style.maxHeight = prev.maxHeight;
        content.style.transition = prev.transition;
        content.style.overflow = prev.overflow;
        return h;
    }

    function openContent(content) {
        content._closing = false;
        var fullHeight = getFullHeight(content);
        content.style.display = 'block';
        content.style.overflow = 'hidden';
        content.style.maxHeight = '0px';
        content.style.transition = 'none';

        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                content.style.transition = 'max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1)';
                content.style.maxHeight = fullHeight + 'px';
            });
        });
    }

    function closeContent(content) {
        content._closing = true;
        var fullHeight = getFullHeight(content);
        content.style.maxHeight = fullHeight + 'px';
        content.style.overflow = 'hidden';
        content.style.transition = 'none';

        requestAnimationFrame(function () {
            requestAnimationFrame(function () {
                content.style.transition = 'max-height 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
                content.style.maxHeight = '0px';
            });
        });

        function onEnd() {
            if (content._closing) {
                content.style.display = 'none';
                content.style.maxHeight = '';
                content.style.overflow = '';
                content.style.transition = '';
            }
            content.removeEventListener('transitionend', onEnd);
        }
        content.addEventListener('transitionend', onEnd);
    }

    function resetContent(content) {
        content.style.display = '';
        content.style.maxHeight = '';
        content.style.overflow = '';
        content.style.transition = '';
    }

    function init() {
        document.querySelectorAll('.tt-mobile-collapse').forEach(function (collapse) {
            var title   = collapse.querySelector('.tt-collapse-title');
            var content = collapse.querySelector('.tt-collapse-content');
            if (!title || !content) return;

            if (isMobile()) {
                if (!title.classList.contains('tt-open')) {
                    content.style.display = 'none';
                } else {
                    animateIn(content);
                }
            }

            new MutationObserver(function () {
                if (!isMobile()) {
                    resetContent(content);
                    return;
                }
                if (title.classList.contains('tt-open')) {
                    openContent(content);
                    setTimeout(function () { animateIn(content); }, 50);
                } else {
                    animateOut(content);
                    closeContent(content);
                }
            }).observe(title, { attributes: true, attributeFilter: ['class'] });
        });

        window.addEventListener('resize', function () {
            if (!isMobile()) {
                document.querySelectorAll('.tt-collapse-content').forEach(function (content) {
                    resetContent(content);
                });
            }
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();

// ── CONTADOR WISHLIST EN HEADER ──────────────────────────
function actualizarContadorWishlist() {
    try {
        const data  = JSON.parse(localStorage.getItem('wokiee_wishlist') || '{}');
        const count = Object.keys(data).length;
        const badge = document.querySelector('.tt-wishlist-count');
        if (!badge) return;
        if (count > 0) {
            badge.textContent  = count;
            badge.style.display = 'flex';
        } else {
            badge.style.display = 'none';
        }
    } catch(e) {}
}

document.addEventListener('DOMContentLoaded', actualizarContadorWishlist);
window.addEventListener('storage', actualizarContadorWishlist);
setInterval(actualizarContadorWishlist, 2000);

// ── COMPARTIR WISHLIST Y AÑADIR/ELIMINAR DEL CARRITO ──────────────
(function() {
    if (!window.location.pathname.includes('/pages/wishlist')) return;

    function obtenerHandles() {
        try {
            const data = JSON.parse(localStorage.getItem('wokiee_wishlist') || '{}');
            return Object.values(data).map(url => url.split('/').filter(Boolean).pop());
        } catch(e) { return []; }
    }

    function actualizarBadgeCarrito(itemCount) {
        document.querySelectorAll('.tt-badge-cart').forEach(badge => {
            badge.textContent = itemCount;
            if (itemCount === 0) {
                badge.classList.add('hide');
            } else {
                badge.classList.remove('hide');
            }
        });
    }

    // Generador de HTML para el botón dinámico
    function getBtnHTML(enCarrito) {
        if (enCarrito) {
            return `
                <button class="selene-share-btn" id="selene-dynamic-btn" style="background-color: #333333; color: #ffffff; border: none; font-weight: 600;">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path></svg>
                    Eliminar del carrito
                </button>
            `;
        } else {
            return `
                <button class="selene-share-btn" id="selene-dynamic-btn" style="background-color: #d9765f; color: #ffffff; border: none; font-weight: 600;">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path></svg>
                    Añadir todos al carrito
                </button>
            `;
        }
    }

    async function inyectarBotonCompartir() {
        // Esta línea bloquea las ejecuciones duplicadas inmediatamente
        if (document.querySelector('.selene-title-row')) return;

        const info = document.querySelector('.wkpageinfo');
        if (!info || info.classList.contains('hide')) return;

        const blockTitle = info.querySelector('.tt-block-title');
        if (!blockTitle) return;

        const handles = obtenerHandles();
        if (handles.length === 0) return;

        // INYECCIÓN SÍNCRONA: Creamos los elementos en el DOM inmediatamente
        const row = document.createElement('div');
        row.className = 'selene-title-row';

        blockTitle.parentNode.insertBefore(row, blockTitle);
        row.appendChild(blockTitle);
        blockTitle.removeAttribute('style');

        const wrapper = document.createElement('div');
        wrapper.className = 'selene-share-wrapper';

        const shareUrl = `${window.location.origin}/pages/wishlist-compartida?productos=${handles.join(',')}`;
        const whatsappMsg = encodeURIComponent(`¡Mirá mis favoritos de Selene Joyas! ${shareUrl}`);

        // Insertamos la base con el botón dinámico en estado de "cargando"
        wrapper.innerHTML = `
            <button class="selene-share-btn" id="selene-copy-btn">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg>
                Copiar link
            </button>
            <a class="selene-share-btn selene-share-wa" href="https://wa.me/?text=${whatsappMsg}" target="_blank">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                Compartir por WhatsApp
            </a>
            <div id="selene-dynamic-btn-container" style="display:inline-block;">
                <button class="selene-share-btn" style="background-color: #ccc; color: #fff; border: none; font-weight: 600; opacity: 0.7;">Verificando...</button>
            </div>
        `;
        row.appendChild(wrapper);

        if (window.gsap) {
            gsap.fromTo(wrapper,
                { y: 30, autoAlpha: 0 },
                { y: 0, autoAlpha: 1, duration: 1, ease: "power2.out", delay: 0.4 }
            );
        }

        // PETICIÓN ASÍNCRONA: Ahora sí, sin miedo a duplicados, revisamos el carrito
        let cartData = { items: [] };
        let estanEnCarrito = false;
        try {
            const cartRes = await fetch('/cart.js');
            cartData = await cartRes.json();
            const cartHandles = cartData.items.map(item => item.handle);
            estanEnCarrito = handles.some(h => cartHandles.includes(h));
        } catch (e) {}

        const dynamicBtnContainer = document.getElementById('selene-dynamic-btn-container');
        dynamicBtnContainer.innerHTML = getBtnHTML(estanEnCarrito);

        // Lógica de Copiar Link
        document.getElementById('selene-copy-btn').addEventListener('click', function() {
            navigator.clipboard.writeText(shareUrl).then(() => {
                this.textContent = '¡Link copiado!';
                setTimeout(() => {
                    this.innerHTML = `<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"/><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"/></svg> Copiar link`;
                }, 2000);
            });
        });

        // Lógica del Botón Dinámico (Añadir/Eliminar)
        dynamicBtnContainer.addEventListener('click', async function(e) {
            const btn = e.target.closest('#selene-dynamic-btn');
            if (!btn) return;

            btn.innerHTML = 'Procesando...';
            btn.style.opacity = '0.7';
            btn.style.pointerEvents = 'none';

            if (!estanEnCarrito) {
                // AÑADIR AL CARRITO
                let itemsToAdd = [];
                for (const handle of handles) {
                    try {
                        const response = await fetch(`/products/${handle}.js`);
                        const product = await response.json();
                        const variant = product.variants.find(v => v.available);
                        if (variant) itemsToAdd.push({ id: variant.id, quantity: 1 });
                    } catch (err) {}
                }

                if (itemsToAdd.length > 0) {
                    await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ items: itemsToAdd })
                    });
                    estanEnCarrito = true;
                    dynamicBtnContainer.innerHTML = getBtnHTML(true);
                } else {
                    btn.innerHTML = 'Sin stock disponible';
                    setTimeout(() => { dynamicBtnContainer.innerHTML = getBtnHTML(false); }, 2000);
                }

            } else {
                // ELIMINAR DEL CARRITO
                const currentCartRes = await fetch('/cart.js');
                const currentCartData = await currentCartRes.json();
                
                let updates = {};
                currentCartData.items.forEach(item => {
                    if (handles.includes(item.handle)) {
                        updates[item.key] = 0;
                    }
                });

                if (Object.keys(updates).length > 0) {
                    await fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ updates })
                    });
                }
                estanEnCarrito = false;
                dynamicBtnContainer.innerHTML = getBtnHTML(false);
            }

            // Actualizamos el contador del menú
            const newCartRes = await fetch('/cart.js');
            const newCartData = await newCartRes.json();
            actualizarBadgeCarrito(newCartData.item_count);
        });
    }

    const observer = new MutationObserver(() => {
        const info = document.querySelector('.wkpageinfo');
        if (info && !info.classList.contains('hide')) {
            setTimeout(inyectarBotonCompartir, 300);
        }
    });

    observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

    setTimeout(inyectarBotonCompartir, 500);
    setTimeout(inyectarBotonCompartir, 1000);
    setTimeout(inyectarBotonCompartir, 2000);
})();

// =======================================================
// QUICK VIEW EN WISHLIST
// =======================================================
document.addEventListener("DOMContentLoaded", () => {
    if (!window.location.pathname.includes('/pages/wishlist')) return;

    const container = document.querySelector('.tt-layout-product-item');
    if (!container) return;

    const productoCache = {};

    function crearBotonNativo(imageBox, handle, ruta) {
        if (imageBox.querySelector('.tt-btn-quickview')) return;

        const placeholder = document.createElement('a');
        placeholder.className = "tt-btn-quickview wk-placeholder";
        placeholder.href = "#";
        imageBox.appendChild(placeholder);

        const cargar = (data) => {
            placeholder.remove();
            if (!imageBox.querySelector('.tt-btn-quickview')) {
                const v = data.variants[0];

                const optionImages = {};
                if (data.options && data.options.length > 0) {
                    const colorOption = data.options.find(o =>
                        ['color','colour','color/talla','color/size'].includes(o.name.toLowerCase())
                    ) || data.options[0];
                    const idx = data.options.indexOf(colorOption);
                    data.variants.forEach(variant => {
                        const key = variant[`option${idx + 1}`];
                        if (key && variant.featured_image) {
                            optionImages[key] = variant.featured_image.src;
                        }
                    });
                }

                const quantities = data.variants
                    .map(v => `${v.id}-${v.available ? 30 : 0}`)
                    .join(';');

                const btn = document.createElement('a');
                btn.href      = "#";
                btn.className = "tt-btn-quickview";
                btn.setAttribute("data-toggle",         "modal");
                btn.setAttribute("data-target",         "#ModalquickView");
                btn.setAttribute("data-value",          ruta);
                btn.setAttribute("data-firstvariantid", String(v.id));
                btn.setAttribute("data-quantity",       quantities);
                btn.setAttribute("data-optionimages",   JSON.stringify(optionImages));
                btn.setAttribute("tabindex",            "-1");

                imageBox.appendChild(btn);
                console.log('[QV Wishlist] Botón nativo construido para:', handle);
            }
        };

        if (productoCache[handle]) {
            cargar(productoCache[handle]);
        } else {
            fetch(`/products/${handle}.js`)
                .then(r => r.json())
                .then(data => {
                    productoCache[handle] = data;
                    cargar(data);
                })
                .catch(() => {
                    placeholder.remove();
                    console.warn('[QV Wishlist] Error cargando datos de:', handle);
                });
        }
    }

    function inyectarBotones() {
        container.querySelectorAll('.tt-product').forEach(product => {
            const imageBox = product.querySelector('.tt-image-box');
            if (!imageBox || imageBox.querySelector('.tt-btn-quickview')) return;

            const productLink = product.querySelector('a[href*="/products/"]');
            if (!productLink) return;

            const href       = productLink.getAttribute('href');
            const rutaLimpia = href.split('?')[0];
            const handle     = rutaLimpia.split('/').filter(Boolean).pop();

            crearBotonNativo(imageBox, handle, rutaLimpia);
        });
    }

    inyectarBotones();
    new MutationObserver(inyectarBotones).observe(container, { childList: true, subtree: true });
});

// ── CARRITO: IR DIRECTO A /cart (MOBILE Y DESKTOP) ─────────────────
(function() {
    function fixCarritoDirecto() {
        // Eliminamos el 'if' que bloqueaba las pantallas grandes para que funcione en todas

        const selectores = [
            '.tt-mobile-parent-cart',
            '.tt-desctop-parent-cart', // Agregamos el contenedor de escritorio
            '.tt-obj-cart',
            '.tt-stuck-parent-cart'
        ];

        selectores.forEach(function(sel) {
            document.querySelectorAll(sel).forEach(function(el) {
                // Evitar doble binding
                if (el.dataset.carritoFixed) return;
                el.dataset.carritoFixed = '1';

                el.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopImmediatePropagation();
                    window.location.href = '/cart';
                }, true); // capture: true para interceptar antes que el tema
            });
        });
    }

    document.addEventListener('DOMContentLoaded', function() {
        fixCarritoDirecto();
        // Re-ejecutar después de que el tema inyecte los íconos dinámicamente
        setTimeout(fixCarritoDirecto, 500);
        setTimeout(fixCarritoDirecto, 1500);
    });

    window.addEventListener('resize', fixCarritoDirecto);
})();